import React, { useState } from 'react';
import { simpleMarkdown } from './blocks/TextBlock';

export function ReportSummary({ summary }) {
    const [expanded, setExpanded] = useState(false);

    if (!summary) return null;

    const isLong = summary.length > 300;
    const displayText = isLong && !expanded ? summary.substring(0, 300) + '...' : summary;

    return (
        <section className="report-summary">
            <h2 className="summary-title">Resumen Ejecutivo</h2>
            <div className="summary-content">
                <div dangerouslySetInnerHTML={{ __html: simpleMarkdown(displayText) }} />
                {isLong && (
                    <button
                        className="summary-toggle"
                        onClick={() => setExpanded(!expanded)}
                    >
                        {expanded ? 'Ver menos' : 'Ver mas'}
                    </button>
                )}
            </div>
        </section>
    );
}
